import { useContext, useEffect, useMemo, useState } from "react"
import _ from "underscore";
import { callautopopulate } from "../../../services/callautopop";
import { ToastContext } from "../../../context/ToastContext";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { DateTime } from "luxon";
import { dateConvert } from "../../../utils/Helper";

export const useChartConfig = ({ createChart, rowData, columnDefs }) => {
    const { showInfo, showError, showSuccess } = useContext(ToastContext);
    const [showCreateChart, setShowCreateChart] = useState(false);
    const [createOpts, setCreateOpts] = useState({ chartOpts: [], xAxisOpts: [], yAxisOpts: [{ label: "employees", value: "employees" }], chartAnalyticsOpts: [] });
    const [createChartValues, setCreateChartValues] = useState({ chartName: "", chartType: {}, xAxis: "", yAxis: "", chartAnalytics: {}, chart_configuration_id: 0, width: 50, height: 300, chart_order: 0 })
    const [data, setData] = useState([]);
    const [showPrompt, setShowPrompt] = useState(false);
    const [allCharts, setAllCharts] = useState([]);
    const [idToDelete, setIdToDelete] = useState(0);
    const [loader, setLoader] = useState({ chart: false, btn: false });
    const [detailsView, setDetailsView] = useState({
        visible: false, data: [], header: "", column_def: [
            {
                field: "srno",
                headerName: "S.No",
                display_order: -1,
                valueGetter: (params) => params.node.rowIndex + 1,
                width: 50,
                sortable: false,
                pinned: "left",
                cellStyle: { textAlign: "center" }
            },
            {
                field: "employee_id",
                headerName: "Employee Id",
                width: "30%",
                minWidth: 140,
                suppressHeaderMenuButton: true,
                filter: true,
                pinned: "left",
                cellStyle: { textAlign: "left" },
                cellRenderer: function (params) {
                    return <div className="d-flex justify-content-between align-items-center gap-1">
                        {params?.value}
                    </div>
                }
            },
            {
                field: "user_display_name",
                headerName: "Employee Name",
                width: "40%",
                minWidth: 130,
                suppressHeaderMenuButton: true,
                filter: true,
                pinned: "left",
                cellRenderer: function (params) {
                    const check = params?.data?.is_leaving_date || params?.data?.is_resignation_date
                    const today = new Date();
                    const targetDate = new Date(params?.data?.leaving_date);
                    today.setHours(0, 0, 0, 0);
                    targetDate.setHours(0, 0, 0, 0);
                    const diffInMilliseconds = targetDate.getTime() - today.getTime();
                    const oneDay = 1000 * 60 * 60 * 24;
                    const diffInDays = Math.round(diffInMilliseconds / oneDay);
                    return (
                        <div className="">
                            {params.data.user_display_name !== undefined &&
                                <div className="d-flex gap-1">
                                    <div className="">
                                        <div
                                            className="rounded-circle position-relative "
                                            style={{ border: check && "2px solid rgb(188, 7, 7)", width: "30px", height: "30px" }}
                                            title={params?.data?.is_leaving_date ? "Leaving in 3 days" : params?.data?.is_resignation_date ? "Resign in last 2 days" : params.data?.user_display_name}
                                        >
                                            <img
                                                src={`${params.data?.image_url}?nocache=${Date.now()}`}
                                                onError={(e) => { e.target.onerror = null; e.target.src = "/assets/grey-user-icon.png"; }}
                                                className="rounded-circle"
                                                width={20}
                                                height={20}
                                                alt=" "
                                            />
                                            {
                                                (params?.data?.leaving_date && diffInDays > 0) && <div style={{ position: "absolute", top: "-2px", right: "0px", background: "#0055cc", lineHeight: "normal", borderRadius: "10px", color: "white", padding: "0px 2px" }} title="Leaving Days" >{diffInDays}</div>
                                            }
                                        </div>
                                    </div>
                                    {params.data?.user_display_name}
                                </div>
                            }
                        </div>
                    )
                }
            },
            {
                field: "reporting_manager_name",
                headerName: "Reporting Manager",
                width: "50%",
                minWidth: 125,
                pinned: "left",
                cellStyle: { textAlign: "left" },
                suppressHeaderMenuButton: true,
                filter: true,
                cellRenderer: (params) => {
                    const isClient = params.data.is_client;
                    return <div className="d-flex justify-content-between">
                        <div className="w90 text-truncate" title={params?.value}>{params?.value}</div>
                    </div>
                }
            },
            {
                field: "user_status_name",
                headerName: "Status",
                width: 120,
                pinned: "left",
                filter: true,
                headerClass: "header-wrap",
                cellStyle: { textAlign: "center" },
                cellRenderer: (params) => {
                    return (
                        <div>
                            {params?.value || ""}
                        </div>
                    )
                }
            },
            {
                field: "email_id",
                headerName: "Email",
                width: "30%",
                minWidth: 150,
                suppressHeaderMenuButton: true,
                filter: true,
                cellStyle: { textAlign: "left" },
            },
            {
                field: "primary_phone",
                headerName: "Mobile",
                width: "30%",
                cellStyle: { textAlign: "center" },
                minWidth: 130,
                suppressHeaderMenuButton: true,
                filter: true,
            },
            {
                field: "role_on_project",
                headerName: "Role On Project",
                width: "100%",
                minWidth: 200,
                suppressHeaderMenuButton: true,
                filter: true,
                cellRenderer: function (params) {
                    return (
                        <div>
                            {params.data.role_on_project !== undefined &&
                                <div>{params.data?.role_on_project?.split(",")?.join(", ")}</div>
                            }
                        </div>
                    )
                }
            },
            {
                field: "primary_skill_1",
                headerName: "Primary TechnoLogy",
                width: "30%",
                minWidth: 100,
                cellStyle: { textAlign: "left" },
                suppressHeaderMenuButton: true,
                filter: true,
                headerClass: "header-wrap"
            },
            {
                field: "secondary_skill_1",
                headerName: "Secondary TechnoLogy",
                width: "30%",
                minWidth: 100,
                cellStyle: { textAlign: "left" },
                suppressHeaderMenuButton: true,
                filter: true,
                headerClass: "header-wrap"
            },
            {
                field: "confirmation_date",
                headerName: "Confirmation Date",
                width: "30%",
                minWidth: 100,
                cellStyle: { textAlign: "center" },
                suppressHeaderMenuButton: true,
                filter: true,
                headerClass: "header-wrap",
                valueGetter: params => params.data?.confirmation_date ? DateTime.fromISO(params.data?.confirmation_date).toFormat('dd MMM yyyy') : '',
            },
            {
                field: "joining_date",
                headerName: "Join Date",
                width: "30%",
                minWidth: 100,
                cellStyle: { textAlign: "center" },
                suppressHeaderMenuButton: true,
                filter: true,
                valueGetter: params => params.data?.joining_date ? DateTime.fromISO(params.data?.joining_date).toFormat('dd MMM yyyy') : '',
            },
            {
                field: "srkay_exp",
                headerName: "Company Age",
                width: "30%",
                minWidth: 120,
                cellStyle: { textAlign: "left" },
                suppressHeaderMenuButton: true,
                filter: true,
            },
            {
                field: "total_work_experience",
                headerName: "Total Experience",
                width: "30%",
                minWidth: 120,
                cellStyle: { textAlign: "left" },
                suppressHeaderMenuButton: true,
                filter: true,
                headerClass: "header-wrap"
            },
            {
                field: "resignation_date",
                headerName: "Resign Date",
                width: "30%",
                minWidth: 100,
                cellStyle: { textAlign: "center" },
                suppressHeaderMenuButton: true,
                filter: true,
                cellRenderer: function (params) {
                    const formattedDate = DateTime.fromISO(params.data?.resignation_date).toFormat('dd MMM yyyy')
                    return (
                        <div>
                            {params.data?.resignation_date && <div >{formattedDate}</div>}
                        </div>
                    )
                }
            },
            {
                field: "leaving_date",
                headerName: "Leave Date",
                width: "30%",
                minWidth: 100,
                cellStyle: { textAlign: "center" },
                suppressHeaderMenuButton: true,
                filter: true,
                valueGetter: params => params.data?.leaving_date ? DateTime.fromISO(params.data?.leaving_date).toFormat('dd MMM yyyy') : '',
            },
            {
                field: "business_unit",
                headerName: "Business Unit",
                width: "20%",
                minWidth: 90,
                cellStyle: { textAlign: "left" },
                suppressHeaderMenuButton: true,
                filter: true,
            },
            {
                field: "sub_business_unit",
                headerName: "Sub Business Unit",
                width: "30%",
                minWidth: 120,
                headerClass: "header-wrap",
                cellStyle: { textAlign: "left" },
                suppressHeaderMenuButton: true,
                filter: true,
            },
            {
                field: "sub_business_unit_2",
                headerName: "Sub Business Unit 2",
                width: "30%",
                minWidth: 120,
                headerClass: "header-wrap",
                cellStyle: { textAlign: "left" },
                suppressHeaderMenuButton: true,
                filter: true,
            },
            {
                field: "location",
                headerName: "Location",
                width: "20%",
                minWidth: 70,
                cellStyle: { textAlign: "left" },
                suppressHeaderMenuButton: true,
                filter: true,
            },
            {
                field: "gender",
                headerName: "Gender",
                width: "30%",
                minWidth: 60,
                cellStyle: { textAlign: "left" },
                suppressHeaderMenuButton: true,
                filter: true,
            },
            {
                field: "primary_project",
                headerName: "Primary Project",
                width: "40%",
                minWidth: 125,
                suppressHeaderMenuButton: true,
                filter: true,
                cellStyle: { textAlign: "left" },
                cellRenderer: (params) => {
                    return (
                        <div>
                            {params.value &&
                                <div title={`Effective Date:${dateConvert(params?.data?.effective_date)}`}>{params.value} </div>
                            }
                        </div>
                    )
                }

            },
            {
                field: "secondary_project",
                headerName: "Secondary Project",
                width: "30%",
                minWidth: 125,
                suppressHeaderMenuButton: true,
                filter: true,
                cellStyle: { textAlign: "left" },
            },
        ]
    });

    useEffect(() => {
        callautopopulate("chart_type", "chart_analytics").then((res) => {
            setCreateOpts((prev) => ({ ...prev, chartOpts: _.sortBy(res?.chart_type, "chart_type_name"), chartAnalyticsOpts: _.sortBy(res?.chart_analytics, "chart_analytic_name") }));
        })
    }, [])

    useEffect(() => {
        if (createChart) {
            handleReset();
            setShowCreateChart(true);
        }
    }, [createChart])

    useEffect(() => {
        if (!_.isEmpty(rowData) && !_.isEmpty(createOpts?.chartOpts) && !_.isEmpty(createOpts?.chartAnalyticsOpts)) {
            getXAxisOpts();
            getChartConfiguration();
        } else if (_.isEmpty(rowData)) {
            setAllCharts([]);
        }
    }, [rowData, createOpts?.chartOpts, createOpts?.chartAnalyticsOpts])

    useEffect(() => {
        getFormattedData(createChartValues);
    }, [createChartValues.xAxis, createChartValues.yAxis])

    const getChartConfiguration = async (chartScopeKey) => {
        setLoader((prev) => ({ ...prev, chart: true }));
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETCHARTCONFIGURATION"), { chart_scope_key: chartScopeKey || "team_list" });
            if (res) {
                const getData = _.sortBy(res?.body?.data?.chart_congifuration, "order_number");
                getData.forEach((item) => {
                    const type = _.findWhere(createOpts.chartOpts, { chart_type_id: item?.chart_type_id });
                    const analytics = _.findWhere(createOpts.chartAnalyticsOpts, { chart_analytic_id: item?.chart_analytic_id })
                    const chartData = {
                        xAxis: item?.chart_x_axis === "manager_name" ? "reporting_manager_name" : (item?.chart_x_axis === "category" ? "user_category_name" : item?.chart_x_axis),
                        yAxis: item?.chart_y_axis,
                        chartName: item?.chart_name,
                        chartType: type || "",
                        chartAnalytics: analytics
                    }
                    const formatData = getFormattedData(chartData, true);
                    const options = generateChartOptions(chartData, formatData);
                    item["options"] = options;
                })
                setAllCharts(getData);
                setLoader((prev) => ({ ...prev, chart: false }));
            }
        } catch (error) {
            console.error("error getting charts config", error);
            setLoader((prev) => ({ ...prev, chart: false }));
        }
    }

    const getFormattedData = (value, flag) => {
        let dataValues = [];
        let x = [];
        if (!_.isEmpty(value.xAxis)) {
            dataValues = _.uniq(_.pluck(rowData, value.xAxis));
        }
        dataValues?.forEach((data) => {
            if (data !== null) {
                let obj = {};
                obj[value.xAxis] = data;
                x.push(obj);
            }
        })
        if (!_.isEmpty(value.yAxis)) {
            x?.forEach((item) => {
                let yData = [];
                yData = _.where(rowData, item);
                item[value.yAxis] = yData?.length > 0 ? yData.length : 0
            })
        }
        if (flag) {
            return _.sortBy(x, value.xAxis);
        } else {
            setData(_.sortBy(x, value.xAxis));
        }
    }

    const getXAxisOpts = () => {
        let headers = [];
        let columns = [...columnDefs];
        columns = columns?.filter((item) => { return !item.hide });
        const headerData = _.pluck(columns, "headerName");
        const headerField = _.pluck(columns, "field");
        headerData?.forEach((item, index) => {
            headers.push({ label: item, value: headerField[index] });
        })
        headers.push({ label: "Category", value: "user_category_name" })
        const xOpts = _.sortBy(_.filter(headers, (item) => item?.value !== "edit" && item?.value !== "jira_data" && item?.value !== "notes_count"), "label")
        setCreateOpts((prev) => ({ ...prev, xAxisOpts: xOpts }));
    }

    const generateChartOptions = (value, axisData) => {
        let seriesData = [];
        let sum = 0;

        if (value?.chartType?.chart_type_key === 'pie') {
            seriesData = [
                {
                    name: value.yAxis,
                    colorByPoint: true,
                    data: axisData.map((item) => ({
                        name: item[value.xAxis],
                        y: item[value.yAxis],
                    })),
                },
            ];
        } else {
            seriesData = [{ name: value.yAxis, data: axisData.map((item) => item[value.yAxis]) }]
        }

        seriesData?.[0]?.data?.forEach((val) => {
            sum += val?.y !== undefined ? val?.y : val;
        })

        return {
            chart: {
                type: value?.chartType?.chart_type_key,
            },
            credits: {
                enabled: false
            },
            title: {
                text: `${value.chartName} (${sum})`,
            },
            xAxis: {
                categories: axisData.map((item) => item[value.xAxis]),
            },
            yAxis: {
                title: {
                    text: value.yAxis,
                },
                min: 0,
            },
            series: seriesData,
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b> ( {point.y} ) [{point.percentage:.1f} %]',
                    },
                    point: {
                        events: {
                            click: function (e) {
                                handleShowDetailsPopup(e, value, true);
                            }
                        }
                    },
                },
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            var pcnt = (this.y / this?.series?.data.map(p => p.y).reduce((a, b) => a + b, 0)) * 100;
                            return `${this.y} [ ${parseInt(pcnt || 0) + '%'} ]`;
                        }
                    },
                    point: {
                        events: {
                            click: function (e) {
                                handleShowDetailsPopup(e, value, false);
                            }
                        }
                    },
                }
            },
        };
    };

    const chartOptions = generateChartOptions(createChartValues, data);

    const handleReset = () => {
        setCreateChartValues((prev) => ({ ...prev, chartName: '', chartType: {}, xAxis: '', yAxis: '', chartAnalytics: {}, chart_configuration_id: 0, width: 50, height: 300, chart_order: 0 }))
    }

    const handleSave = async (createParams) => {
        const createValues = createParams || createChartValues;
        if (createValues?.chartName?.length === 0 && !createParams) {
            showInfo("info", "Please enter the chart name");
            return;
        } else if (_.isEmpty(createValues?.chartType)) {
            showInfo("info", "Please select chart type");
            return;
        } else if (createValues?.xAxis?.length === 0) {
            showInfo("info", "Please select x axis");
            return;
        } else if (createValues?.yAxis?.length === 0 && !createParams) {
            showInfo("info", "Please select y axis");
            return;
        } else if (_.isEmpty(createValues?.chartAnalytics) && !createParams) {
            showInfo("info", "Please select chart analytics");
            return;
        } else if ((createValues?.width === 0 || createValues?.width === null) && !createParams) {
            showInfo("info", "Please enter chart width");
            return;
        } else if ((parseInt(createValues?.height) === 0 || createValues?.height === null || createValues?.height?.length === 0) && !createParams) {
            showInfo("info", "Please enter chart height");
            return;
        } else if ((createValues?.chart_order === 0 || createValues?.chart_order === null) && !createParams) {
            showInfo("info", "Please enter chart order");
            return;
        } else {
            try {
                setLoader((prev) => ({ ...prev, btn: true }));
                const payload = {
                    "chart_configuration_id": createValues?.chart_configuration_id || 0,
                    "chart_type_id": createValues?.chartType?.chart_type_id || 0,
                    "chart_name": createValues?.chartName || "",
                    "chart_analytic_id": createValues?.chartAnalytics?.chart_analytic_id || 0,
                    "chart_x_axis": createValues?.xAxis || "",
                    "chart_y_axis": createValues?.yAxis || "",
                    "chart_width": parseInt(createValues?.width) || 0,
                    "chart_height": parseInt(createValues?.height) || 0,
                    "order_number": parseInt(createValues?.chart_order) || 0,
                    "chart_scope_key": (createValues ? createValues?.chart_scope_key : "team_list") || ""
                }
                const res = await services.getInvokeRemote("POST", Urls("CHARTCONFIGURATIONUPSERT"), payload);
                if (!res?.body?.error_status) {
                    showSuccess("Success", res?.body?.message);
                    setShowCreateChart(false);
                    await getChartConfiguration(payload?.chart_scope_key);
                    setLoader((prev) => ({ ...prev, btn: false }));
                } else {
                    showError("error", res?.body?.message);
                    setLoader((prev) => ({ ...prev, btn: false }));
                }
            } catch (error) {
                console.error("error saving chart config", error);
                showError("error", error?.response?.data?.errorMessage);
                setLoader((prev) => ({ ...prev, btn: false }));
            }
        }
    }

    const handleEdit = (chartData) => {
        const type = _.findWhere(createOpts.chartOpts, { chart_type_id: chartData?.chart_type_id });
        const analytics = _.findWhere(createOpts.chartAnalyticsOpts, { chart_analytic_id: chartData?.chart_analytic_id })
        setCreateChartValues((prev) => ({ ...prev, chartName: chartData?.chart_name, xAxis: chartData?.chart_x_axis === "manager_name" ? "reporting_manager_name" : (chartData?.chart_x_axis === "category" ? "user_category_name" : chartData?.chart_x_axis), yAxis: chartData?.chart_y_axis, chartType: type, chartAnalytics: analytics, chart_configuration_id: chartData?.chart_configuration_id, width: chartData?.chart_width, height: chartData?.chart_height, chart_order: chartData?.order_number }));
        setShowCreateChart(true);
    }

    const handleDelete = async (deletechart) => {
        try {
            const payload = {
                chart_configuration_id: deletechart ? deletechart?.chart_configuration_id : idToDelete
            }
            const res = await services.getInvokeRemote("POST", Urls("CHARTCONFIGURATIONDELETE"), payload);
            if (res) {
                showSuccess("success", res?.body?.message);
                setShowPrompt(false);
                getChartConfiguration(deletechart ? deletechart?.chart_scope_key : null);
            }
        } catch (error) {
            console.error("error deleting chart", error);
        }
    }

    const handleShowDetailsPopup = (event, value, isPie) => {
        if (event?.point) {
            const clickedPoint = event?.point;
            const filteredData = _.filter(rowData, item => item?.[value?.xAxis] === (isPie ? clickedPoint?.name : clickedPoint?.category))
            setDetailsView((prev) => ({ ...prev, visible: true, data: filteredData, header: `${value?.chartName} - ${isPie ? clickedPoint?.name : clickedPoint?.category}` }));
        }
    }

    return useMemo(() => ({
        allCharts, createChartValues, setCreateChartValues, chartOptions, showCreateChart, setShowCreateChart, createOpts, handleSave, handleEdit, handleDelete, showPrompt, setShowPrompt, setIdToDelete, loader, detailsView, setDetailsView, getChartConfiguration
    }), [allCharts, createChartValues, setCreateChartValues, chartOptions, showCreateChart, setShowCreateChart, createOpts, handleSave, handleEdit, handleDelete, showPrompt, setShowPrompt, setIdToDelete, loader, detailsView, setDetailsView, getChartConfiguration])
}